export const spacing = [
  '2px',
  '4px',
  '8px',
  '12px',
  '16px',
  '24px',
  '32px',
  '40px',
  '48px',
  '64px',
  '80px',
  '96px',
  '160px',
] as const;
